"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookUpService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const look_up_repository_1 = require("./look-up.repository");
const constants_1 = require("../../../../service-lib/src/lib/constants");
let LookUpService = class LookUpService {
    constructor(lookUpRepository) {
        this.lookUpRepository = lookUpRepository;
    }
    /**
     * Retrieves all LookUps by delegating the repository.
     */
    async getAllLookUps(search, sortBy = "id", sortOrder = "ASC", page = constants_1.DEFAULT_VALUES.PAGE, limit = constants_1.DEFAULT_VALUES.LIMIT) {
        try {
            const lookUps = await this.lookUpRepository.getAllLookUps(search, sortBy, sortOrder, page, limit);
            return lookUps;
        }
        catch (error) {
            console.error("Error in Fetching LookUps:", error);
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to retrieve LookUps");
        }
    }
    /**
     * Creates a new LookUp by delegating to the repository.
     */
    async createLookUp(createLookUpDto) {
        try {
            return this.lookUpRepository.createLookUp(createLookUpDto);
        }
        catch (error) {
            console.error("Error creating LookUp:", error);
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to create LookUp"));
        }
    }
    /**
     * Delegates the retreival of a LookUp by ID to the repository.
     */
    async getLookUpById(id) {
        try {
            return this.lookUpRepository.getLookUpById(id);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to find LookUp"));
        }
    }
    /**
     * Delegates the updation of a LookUp by ID to the repository.
     */
    async updateLookUpById(id, updateLookUpDto) {
        try {
            return this.lookUpRepository.updateLookUpById(id, updateLookUpDto);
        }
        catch (error) {
            console.error("Error updating LookUp:", error);
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to update LookUp"));
        }
    }
    /**
     * Delegates the deletion of a LookUp by ID to the repository.
     */
    async deleteLookUpById(id) {
        try {
            return this.lookUpRepository.deleteLookUpById(id);
        }
        catch (error) {
            console.error("Error deleting LookUp:", error);
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to delete LookUp"));
        }
    }
    /**
     * Get lookup values by delegating the repository.
     */
    async getLookUpsByName(lookUpName) {
        try {
            return await this.lookUpRepository.findByLookUpName(lookUpName);
        }
        catch (error) {
            console.error("Error in Fetching LookUps:", error);
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to retrieve LookUps"));
        }
    }
    /**
     * Get lookup values using look up key by delegating the repository
     */
    async getLookUpsByKey(lookUpKey) {
        try {
            return await this.lookUpRepository.findByLookUpKey(lookUpKey);
        }
        catch (error) {
            console.error("Error in Fetching LookUps:", error);
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to retrieve LookUps"));
        }
    }
    /**
     * Retrieves distinct lookup names.
     */
    async getDistinctLookUpNames() {
        try {
            return this.lookUpRepository.getDistinctLookUpNames();
        }
        catch (error) {
            console.error("Error in Fetching Distinct LookUp Names:", error);
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "Failed to retrieve LookUp Names"));
        }
    }
    /**
     * Retrieves LookUp records based on a list of lookup names.
     */
    async getLookUpsByNames(lookupNames) {
        try {
            // Ensure lookupNames is valid
            if (!Array.isArray(lookupNames) || lookupNames.length === 0) {
                throw new Error("lookupNames must be a non-empty array");
            }
            const lookUpRecords = await this.lookUpRepository.findByLookupNames(lookupNames);
            // Transform the result into the desired format
            const transformedRecords = lookupNames.reduce((acc, name) => {
                acc[name] = lookUpRecords
                    .filter((record) => record.lookUpName === name)
                    .map((record) => ({
                    id: record.id,
                    lookUpValue: record.lookUpValue,
                    lookUpKey: record.lookUpKey,
                }));
                return acc;
            }, {});
            return transformedRecords;
        }
        catch (error) {
            console.error("Error in Fetching LookUp Records:", error);
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : "Failed to retrieve LookUp records");
        }
    }
};
exports.LookUpService = LookUpService;
exports.LookUpService = LookUpService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof look_up_repository_1.LookUpRepository !== "undefined" && look_up_repository_1.LookUpRepository) === "function" ? _a : Object])
], LookUpService);
